import styled from "styled-components";


const PrimaryButtonStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['primary', 'justifycontent'].includes(prop)
})`
    border: none;
    background: none;
    display: flex;
    justify-content: ${({justifycontent})=> justifycontent || 'center'};
    width: ${({width})=> width || 'fit-content'};
    margin: 0 auto;
    cursor: pointer;


    a{
        background: linear-gradient(to left, #39686B, #6FCBD1);
        opacity: ${({disabled})=> disabled ? 0.5 : 1};
        cursor: ${({disabled})=> disabled ? 'not-allowed' : 'pointer'};
        width: ${({width})=> width || 'fit-content'};
        margin: ${({margin})=> margin || '0'};
        color: #fff;
        border-radius: 1.5rem;
        padding: 0.7rem;
        /* Prevent hover-induced layout shift by reserving border space */
        box-sizing: border-box;
        border: 1px solid transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        transition: 0.5s ease-in-out;
        &:hover{
            background: linear-gradient(to left, #0c1e28, #6fcbd1);
            /* Only change border color on hover (width already reserved) */
            border-color: ${({ theme }) => theme === 'dark' ? '#6fcbd1' : 'transparent'};
            box-shadow: ${({ theme }) => theme === 'dark' ? '0px 4px 8px 0px rgba(111, 203, 209, 0.25)' : '0px 3px 4px 0px rgba(0, 0, 0, 0.7)'};

        }
    }
    
`;

const AltButtonStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['alternate'].includes(prop)
})`
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    width: ${({width})=> width || 'fit-content'};
    margin: 0 auto;
    cursor: pointer;


    a{
        border: 1px solid #0C1E28;
        background: ${({$bg})=> $bg || '#0C1E28'};
        width: ${({width})=> width || 'fit-content'};
        border-radius: 1.5rem;
        margin: ${({margin})=> margin || '0'};
        color: #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        padding: ${({$pad})=> $pad || '0.7rem'};
        transition: 0.5s ease-in-out;
        text-align: center;
        &:hover{
            background: #70cbd2;
            color: #fff;
            border: none;
        }
    }
    
`;

const AltLightButtonStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['alternate'].includes(prop)
})`
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    width: ${({width})=> width || 'fit-content'};
    margin: 0 auto;
    cursor: pointer;


    a{
        border: 1px solid #0C1E28;
        background: ${({$bg})=> $bg || '#0C1E28'};
        width: ${({width})=> width || 'fit-content'};
        border-radius: 1.5rem;
        margin: ${({margin})=> margin || '0'};
        color: #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        padding: ${({$pad})=> $pad || '0.7rem'};
        transition: 0.5s ease-in-out;
        text-align: center;
        &:hover{
            background: #70cbd2;
            color: #fff;
            border: none;
        }
    }
    
`;

const SecondaryButtonStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['secondary'].includes(prop)
})`
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    width: ${({width})=> width || 'fit-content'};
    cursor: pointer;


    a{
        border: .1rem solid #fff;
        background: ${({$bg})=> $bg || 'none'};
        width: ${({width})=> width || 'fit-content'};
        border-radius: 1.5rem;
        margin: ${({margin})=> margin || '0'};
        color: #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        padding: 0.7rem;
        transition: 0.5s ease-in-out;
        text-align: center;
        &:hover{
            background: rgba(255, 255, 255, 0.2);
            color: #fff;
        }
    }

`;

const SecondaryLightButtonStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['secondary', 'justifycontent'].includes(prop)
})`
    border: none;
    background: none;
    display: flex;
    justify-content: ${({justifycontent})=> justifycontent || 'center'};
    width: ${({width})=> width || 'fit-content'};
    cursor: pointer;


    a{
        border: ${({ $border, $borderColor }) => $border || `.1rem solid ${$borderColor || '#009990'}`};
        background: ${({$bg})=> $bg || 'none'};
        width: ${({width})=> width || 'fit-content'};
        border-radius: 1.5rem;
        margin: ${({margin})=> margin || '0'};
        color: ${({ color }) => color || '#009990'};
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        padding: 0.7rem;
        transition: 0.5s ease-in-out;
        text-align: center;
        &:hover{
            background: rgba(0, 153, 144, 0.2);
            color: ${({ color }) => color || '#009990'};
        }
    }

`;


const CheckoutButtonStyled = styled.button`
    border: 1px solid ${({$borderColor})=> $borderColor || '#6FCBD1' };
    background: ${({$bg})=> $bg || 'none'};
    padding: ${({$pad})=> $pad || '0.27rem 1rem' };
    width: ${({width})=> width || 'fit-content'};
    border-radius: ${({$radius})=> $radius || '1rem'};
    margin: ${({margin})=> margin || '0'};
    color: ${({color})=> color || '#6FCBD1' };
    cursor: pointer;
    position: relative;
    z-index: 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
        border-radius: ${({ $radius }) => $radius || '1rem'};
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-image: ${({$reccomended})=> $reccomended === "true" ? 'linear-gradient(to left, transparent, #5fbec5, transparent)'
:'linear-gradient(to left, transparent, #ddd, transparent)'};
        background-size: 200% 200%;
        background-position: -100% 0;
        animation: ripple 2s ease-in-out infinite;
        z-index: -1;
    }
    a{
        text-align: center;
        color: ${({color})=> color || '#6FCBD1' };

    }

    @keyframes ripple {
        0% {
            background-position: 100% 0;
        }
        100% {
            background-position: -100% 0;
        }
    }

`;


const JobButtonStyled = styled.button`
    border: none;
    background: none;
    width: 100%;
    display: flex;
    justify-content: center;
    a{
        border: ${({ $border, theme, $right }) =>
        theme === 'dark'
            ? $border
            : ($right === 'true' && '1.5px solid #1f9789') || 'none'};
        background: ${({$bg})=> $bg || 'none'};
        width: ${({width})=> width || 'fit-content'};
        border-radius: ${({$radius})=> $radius || '0.625rem'};
        margin: ${({margin})=> margin || '0'};
        color: ${({color, theme, $right})=>
        theme === 'dark'
            ? color :
            ($right === 'true' && '#1f9789') || '#fff' };
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: ${({$pad})=> $pad || '0.27rem 1rem' };
        gap: 0.7rem;
        

    }
  
`


export {PrimaryButtonStyled, SecondaryButtonStyled, SecondaryLightButtonStyled, CheckoutButtonStyled, JobButtonStyled, AltButtonStyled, AltLightButtonStyled};